import { render, staticRenderFns } from "./ConfirmPurchase.vue?vue&type=template&id=3734e1c0&scoped=true"
import script from "./ConfirmPurchase.vue?vue&type=script&lang=js"
export * from "./ConfirmPurchase.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPurchase.vue?vue&type=style&index=0&id=3734e1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734e1c0",
  null
  
)

export default component.exports